<template>
  <div class="container app-container">
    <el-form :inline="true" ref="search" :model="search" class="demo-form-inline">
      <el-form-item prop="coupon_batch">
        <el-input v-model="search.coupon_batch" placeholder="请输入优惠券批次号"></el-input>
      </el-form-item>
      <el-form-item prop="rangeDate">
        <el-date-picker
          v-model="search.rangeDate"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="status">
        <el-select v-model="search.status" placeholder="状态">
          <el-option label="全部" value=""></el-option>
          <el-option label="已发放" value="1"></el-option>
          <el-option label="未使用" value="2"></el-option>
          <el-option label="已使用" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="tel">
        <el-input v-model="search.tel" placeholder="请输入用户姓名/手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchData">查询</el-button>
        <el-button @click="resetForm('search')">重置</el-button>
        <el-button type="primary" @click="handleAddDiscount">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
      max-height="600"
      stripe
    >
      <el-table-column prop="coupon_batch" label="优惠券批次号" align="center" />
      <el-table-column  prop="discount" label="优惠券金额" align="center">
        <template slot-scope="{ row: { discount, discount_num }}">
          {{ `${ discount_num === 1 || discount_num === 0 ? '单': discount_num}次优惠金额${discount}元`}}
        </template>
      </el-table-column>
      <el-table-column prop="num" label="总数量" align="center" />
      <el-table-column prop="send_num" label="已发放" align="center" />
      <el-table-column prop="residue_num" label="剩余" align="center" />
      <el-table-column prop="used_num" label="已使用" align="center" />
      <el-table-column prop="not_used_num" label="未使用" width="auto" align="center" />
      <el-table-column prop="create" label="创建人信息" align="center">
        <template slot-scope="{ row: { username, created_at }}">
          {{ username }}<br>{{ created_at }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="{ row }">
          <i class="el-icon-tickets fz24"  title="详情" @click="handleDiscountDetail(row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page_size"
        :current-page="page_number"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <EditDiscount ref="editDiscount" @update="getList" />
  </div>
</template>

<script>
import { fetchCouponList } from '@/api'
import { OrderPayTypeStatus, OrderPayTypes } from '@/enum/orders'
import { filterEnum } from '@/utils/filter'
import { formatDate } from 'element-ui/lib/utils/date-util'
import EditDiscount from './components/EditDiscount'
import { isEmpty } from '../../utils'
export default {
  name: 'OrdersManage',
  components: { EditDiscount },
  data() {
    return {
      OrderPayTypeStatus,
      OrderPayTypes,
      isAddNurse: false,
      noAuth: false,
      pAuth: false,
      is_finance: false,
      is_hospital: false,
      fileList: [],
      search: {
        coupon_batch: '',
        rangeDate: [] ,
        status: '',
        tel: ''
      },
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      pay_total: 0,
      profit: 0,
      refund_total: 0,
      total: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      tableData: []
    }
  },
  filters: {
    formatDate,
    ordersPayTypeStatusFilter(val) {
      const list = OrderPayTypeStatus.map(i => ({
        ...i,
        val: i.val === 2 ? 0 : i.val
      }))
      return filterEnum(val, list).label || '-'
    },
    orderPayTypesFilter(val) {
      return filterEnum(val, OrderPayTypes).label || '-'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      // status 0 超级管理员 1无权限 2有权限 默认1无权限
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page_number = 1
      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getList()
    },
    handleAddDiscount() {
      this.$refs.editDiscount.handleOpen()
    },
    handleEditDiscount(discount) {
      this.$refs.editDiscount.handleOpen(discount)
    },
    handleDiscountDetail(discount) {
      this.$router.push({
        path: `/discount-detail/${discount.coupon_batch}`
      })
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    getList() {
      this.tableLoading = true
      const { page_size, page_number, search } = this
      const { rangeDate = [], ...searchInfo } = search
      const params = {
        page_size: page_size,
        page_number: page_number,
        ...searchInfo
      }
      if (!isEmpty(rangeDate)) {
        params.start_at = rangeDate[0]
        params.end_at = rangeDate[1]
      }
      this.tableLoading = true
      fetchCouponList(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    width: 100%;

    .imgbox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .litimg {
        width: 30px;
        height: 30px;
        margin: 3px;
        object-fit: cover;
        cursor: zoom-in;
      }
    }

    .picture {
      width: 100%;
    }

    .block {
      text-align: center;
    }

    .el-pagination {
      margin-top: 20px;
    }

    .total {
      padding: 0 6% 15px;
      color: #26A4B2;
      text-align: right;
      font-weight: bold;
    }
  }
</style>
